import { getDateDifference } from "utils/dates"
import { isBlank, isPresent, isEqual } from "utils/helpers"
import { gendersMatch } from "utils/genders_match"

const hasRequiredTypeKeys = type => {
  const requiredKeys = [
    "name",
    "hasGenderRestrictions",
    "genderRestrictionUnit",
    "hasGradeRestrictions",
    "minGrade",
    "maxGrade",
    "hasAgeRestrictions",
    "minAge",
    "maxAge",
    "ageRestrictionUnit",
    "evaluateAgeAt"
  ]

  const isValid = requiredKeys.every(requiredKey => Object.keys(type).includes(requiredKey))

  if (!isValid) {
    console.warn("Restriction Type is missing required keys", requiredKeys)
  }

  return isValid
}

const hasRequiredAttendeeKeys = attendee => {
  const requiredKeys = ["name", "gender", "grade", "age", "ageInMonths", "birthdate"]

  const isValid = requiredKeys.every(requiredKey => Object.keys(attendee).includes(requiredKey))

  if (!isValid) {
    console.warn("Restriction Attendee is missing required keys", requiredKeys)
  }

  return isValid
}

export const isGenderRestricted = (attendee, type) => {
  let restriction = false

  if (type.hasGenderRestrictions && !gendersMatch(type.genderRestrictionUnit, attendee.gender)) {
    restriction = true
  }

  return restriction
}

export const isGradeRestricted = (attendee, type) => {
  let restriction = false

  if (!type.hasGradeRestrictions) {
    return restriction
  }

  if (!isEqual(type.minGrade, "-2") || !isEqual(type.maxGrade, "-2")) {
    if (isBlank(attendee.grade)) {
      restriction = true
    } else if (
      (isPresent(type, "minGrade") && attendee.grade < type.minGrade) ||
      (isPresent(type, "maxGrade") && attendee.grade > type.maxGrade)
    ) {
      restriction = true
    }
  }

  return restriction
}

export const isAgeRestricted = (attendee, type) => {
  let restriction = false

  if (!type.hasAgeRestrictions) {
    return restriction
  }

  const isAgeInYears = isEqual(type.ageRestrictionUnit, 1)

  if (isPresent(type.minAge) || isPresent(type.maxAge)) {
    let attendeeAge = isAgeInYears ? attendee.age : attendee.ageInMonths

    if (isPresent(attendee.birthdate) && isPresent(type.evaluateAgeAt)) {
      attendeeAge = getDateDifference(
        attendee.birthdate,
        type.evaluateAgeAt,
        isAgeInYears ? "year" : "month",
        "YYYY-MM-DD"
      )
    }

    if (isBlank(attendeeAge)) {
      restriction = true
    } else if (
      (isPresent(type.minAge) && attendeeAge < type.minAge) ||
      (isPresent(type.maxAge) && attendeeAge > type.maxAge)
    ) {
      restriction = true
    }
  }

  return restriction
}

export const checkRestrictions = (attendee, type) => {
  if (isBlank(type) || isBlank(attendee)) {
    return null
  }

  // Notify if required fields are missing to check for restrictions
  hasRequiredTypeKeys(type)
  hasRequiredAttendeeKeys(attendee)

  const restrictions = [
    { type: "gender", isRestricted: isGenderRestricted(attendee, type) },
    { type: "grade", isRestricted: isGradeRestricted(attendee, type) },
    { type: "age", isRestricted: isAgeRestricted(attendee, type) }
  ]

  return restrictions
}
